"use client";

import { useState } from "react";
import { useAuth } from "@/contexts/auth-context";

export function ResumeSubscriptionButton() {
  const [loading, setLoading] = useState(false);
  const { refreshUserSubscription } = useAuth();

  const handleResume = async () => {
    const ok = window.confirm(
      "Confirm resumption? Your subscription will resume at the current billing period ends."
    );
    if (!ok) return;

    try {
      setLoading(true);
      const res = await fetch("/api/stripe/resume", { method: "POST" });
      if (!res.ok) {
        throw new Error("Resume failed");
      }
      await refreshUserSubscription();
    } catch (e) {
      alert("Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleResume}
      disabled={loading}
      className="rounded-lg text-xs border pl-2 px-2 py-1 text-gray-900 bg-gray-200 dark:text-white dark:bg-gray-700"
    >
  {loading ? "Processing…" : "Resume"}
    </button>
  );
}
